import { Link, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Button } from "../components/ui/button";
import CatFaceLogo from "../components/CatFaceLogo";
import { getCountry, guvenlikSayfasiAcikMi } from "../country";
import {
  Sparkles,
  Database,
  MapPin,
  Heart,
  ArrowRight,
  Eye,
  Utensils,
  ChevronLeft,
  ChevronRight,
  HandHeart,
  Trophy,
  Home,
  PawPrint,
  Shield,
  Mail,
} from "lucide-react";
import { toast } from "sonner";
import KayipSeridi from "../components/KayipSeridi";
import { getAnimalMode, animalParam } from "../animalMode";
import IlkAcilisTuru from "../components/IlkAcilisTuru";
import anaImg from "../assets/hero/ana.jpg";
import modaImg from "../assets/hero/moda.jpg";
import cihangirImg from "../assets/hero/cihangir.jpg";
import eminonuImg from "../assets/hero/eminonu.jpg";
import geceImg from "../assets/hero/gece.jpg";
import galataImg from "../assets/hero/galata.png";
import { apiBase } from "../apiBase";
import { DESTEK_EPOSTA } from "../lib/iletisim";
import { markaAdi, markaLogosu } from "../lib/marka";

// TEK-5 (29 Agu 2026): backend adresi artik DERLEME ZAMANI sabiti degil.
// Tek uygulama iki ulkeye hizmet ediyor; adres `apiBase()` ile CAGRI
// ANINDA, secili ulkeye gore hesaplaniyor. Modul duzeyinde sabitlenirse
// ulke degisimi yansimaz — bkz. apiBase.js.
const CAT_PHOTOS = [
  "https://images.unsplash.com/photo-1705920999755-1013ae9265b3?crop=entropy&cs=srgb&fm=jpg&w=800&q=80",
  "https://images.unsplash.com/photo-1729019754938-f15ae12fa1db?crop=entropy&cs=srgb&fm=jpg&w=800&q=80",
  "https://images.unsplash.com/photo-1621181987877-7e5f84d496bb?crop=entropy&cs=srgb&fm=jpg&w=800&q=80",
  "https://images.unsplash.com/photo-1609165367730-d1ee39fbb918?crop=entropy&cs=srgb&fm=jpg&w=800&q=80",
];

const SK_LANG_KEY = "sk_lang";

const HERO_SLIDE_META = [
  {
    id: "ana",
    image: anaImg,
    gradient: "bg-gradient-to-br from-amber-300 via-orange-400 to-rose-500",
    accent: "text-amber-200",
  },
  {
    id: "moda",
    image: modaImg,
    gradient: "bg-gradient-to-br from-sky-400 via-cyan-400 to-teal-500",
    accent: "text-cyan-100",
  },
  {
    id: "cihangir",
    image: cihangirImg,
    gradient: "bg-gradient-to-br from-stone-400 via-amber-300 to-orange-400",
    accent: "text-amber-100",
  },
  {
    id: "eminonu",
    image: eminonuImg,
    gradient: "bg-gradient-to-br from-orange-500 via-red-500 to-rose-600",
    accent: "text-rose-100",
  },
  {
    id: "gece",
    image: geceImg,
    gradient: "bg-gradient-to-br from-indigo-700 via-violet-700 to-rose-600",
    accent: "text-violet-100",
  },
  {
    id: "galata",
    image: galataImg,
    gradient: "bg-gradient-to-br from-slate-800 via-indigo-900 to-amber-700",
    accent: "text-amber-200",
  },
];

function readSkLang() {
  try {
    const v = localStorage.getItem(SK_LANG_KEY);
    if (v === "tr" || v === "en" || v === "id") return v;
    // Henüz yazılmadıysa ülkeye göre: Türkiye→tr, Endonezya→id, gerisi→en.
    // (Türkiye dışı için asla "tr" değil — Türkçe sızmasın.)
    try {
      const c = getCountry();
      if (c === "tr") return "tr";
      if (c === "id") return "id";
    } catch { /* getCountry yoksa */ }
    return "en";
  } catch {
    return "tr";
  }
}

/* writeSkLang kaldırıldı — yazma artık i18n setLang'de (üst menü). */

// ⚠️ `logoSrc` ALANI KALDIRILDI (11 Eyl 2026). Her dil kendi ikonunu
// tutuyordu ve ülke hiç sorulmuyordu; Türkiye'de İngilizce açılışta
// "StrayPaw" + pati ikonu çıkıyordu. Marka kararı artık `lib/marka.js`te
// TEK yerde ve `src/marka.bekci.test.js` bu dosyaya ikinci bir kopya
// yazılmasını engelliyor. `appName` alanı DURUYOR: alt bilgi metinleri
// onu kullanıyor ve orası marka bloğu değil.
const LANDING_COPY = {
  tr: {
    aiBadge: "AI · Kedi Kimliği",
    ctaPrimary: "Bir kediyi kaydet",
    ctaSecondary: "Kedi Veritabanı",
    statCats: "Kayıtlı kedi",
    statDogs: "Kayıtlı köpek",
    statAnimals: "Kayıtlı hayvan",
    statSightings: "Bildirilen acil vaka",
    statFeeding: "Besleme noktası",
    statVaccinated: "Aşılı",
    featuresOverline: "Neler yapabilirsin",
    f1Title: "Yapay zekâ ile foto tanıma",
    f1Desc:
      "Kedinin önünü, yanını ve sırtını çek; sistem mahalledeki kayıtlı kedilerle karşılaştırsın. Aynı kedi mi, yeni bir kedi mi — son sözü sen söylersin.",
    f2Title: "Mahalle haritası",
    f2Desc:
      "İstanbul genelinde kedileri, acil vakaları ve besleme noktalarını işaretle. İlçeye, renge, sağlık durumuna göre filtrele.",
    f2Link: "İstanbul Analizi",
    f3Title: "Sağlık ve aşılar",
    f3Desc:
      "Kuduz, FVRCP, kısırlaştırma ve notları takip et. Gönüllüleri ve veterinerleri gerçek kayıtlarla destekle.",
    f4Title: "Acil vaka bildirimi",
    f4Desc:
      "Yardıma muhtaç bir kedi mi gördün? Tek bir konum iğnesi — ya da foto ve konum birlikte — yakındaki gönüllüleri ve veterinerleri 30 saniyede uyarır.",
    f4Link: "Acil vaka bildir",
    overline: "İstanbul · Sokak Hayvanları",
    finalCta: "Mahalleninin kedilerine bugün yardım et.",
    finalCtaSub: "Başlamak için tek bir foto yeterli.",
    heroAria: "İstanbul kedileri tanıtım",
    heroSlides: [
      {
        title: "Her sokak kedisinin bir hikayesi var.",
        body: "Gördüğün kediyi kaydet, takip et ve mahallendeki gönüllülerle paylaş.",
      },
      {
        title: "Bir kap mama, bir hayat değiştirir.",
        body: "Besleme noktalarını işaretle, komşuların ve gönüllüler aynı noktayı görebilsin.",
      },
      {
        title: "Kaybolan patiler daha hızlı bulunsun.",
        body: "Kayıp ve bulunan kedileri konumuyla paylaş, doğru kişilere daha çabuk ulaş.",
      },
      {
        title: "Acil durumlarda zaman kritiktir.",
        body: "Yaralı veya yardıma muhtaç kediler için hızlı bildirim oluştur.",
      },
      {
        title: "Mahalleni kedi dostu yap.",
        body: "Kedileri, gönüllüleri ve güvenli noktaları tek ekranda takip et.",
      },
      {
        title: "Gece de yanlarındayız.",
        body: "Galata'nın ışıklarında bir sokak kedisi — her saat, her mahalle.",
      },
    ],
    appName: "Sokak Kedileri",
    tagline: "İstanbul Sokak Kedileri",
    footerDesc: "İstanbul'un sokak kedileri için özenle hazırlandı. Her pati değerli.",
    footerDiscover: "Keşfet",
    footerCommunity: "Topluluk",
    footerConnect: "İletişim",
    footerLinkMap: "İstanbul Analizi",
    footerLinkIdentify: "Yapay Zeka Tanı",
    footerLinkDatabase: "Kedi Veritabanı",
    footerLinkObservation: "Gözlem Evi",
    footerLinkVolunteers: "Gönüllüler",
    footerLinkLeaderboard: "Sıralama",
    footerLinkBadges: "Rozetler",
    footerLinkSafety: "Güvenlik",
    footerPrivacy: "Gizlilik Politikası",
  },
  en: {
    aiBadge: "AI · Cat Identity",
    ctaPrimary: "Register a cat",
    ctaSecondary: "Cat Database",
    statCats: "Registered cats",
    statDogs: "Registered dogs",
    statAnimals: "Registered animals",
    statSightings: "Reported emergencies",
    statFeeding: "Feeding points",
    statVaccinated: "Vaccinated",
    featuresOverline: "What you can do",
    f1Title: "AI-powered cat recognition",
    f1Desc:
      "Capture the front, side and back; the system compares it with registered cats nearby. Same cat or a new one — you make the final call.",
    f2Title: "Neighborhood map",
    f2Desc:
      "Pin cats, emergencies and feeding stations across your neighbourhood. Filter by area, color or health status.",
    f2Link: "Map",
    f3Title: "Health & vaccinations",
    f3Desc:
      "Track rabies, FVRCP, spay/neuter and notes. Empower local volunteers and vets with real records.",
    f4Title: "Emergency reports",
    f4Desc:
      "Spotted a kitten in trouble? Drop a location pin — or add a photo with the location — in 30 seconds and alert nearby volunteers and vets.",
    f4Link: "Report an emergency",
    overline: "Your Neighbourhood · Community Cat Welfare",
    finalCta: "Help your neighborhood cats today.",
    finalCtaSub: "It only takes a photo to start.",
    heroAria: "Street cats showcase",
    heroSlides: [
      {
        title: "Every street cat has a story.",
        body: "Register the cat you see, track it and share with volunteers in your neighborhood.",
      },
      {
        title: "One bowl of food can change a life.",
        body: "Mark feeding spots so neighbors and volunteers can see the same location.",
      },
      {
        title: "Lost paws found faster.",
        body: "Share lost and found cats with location so the right people reach them quickly.",
      },
      {
        title: "Time matters in emergencies.",
        body: "Create a quick report for injured cats or cats that need help.",
      },
      {
        title: "Make your neighborhood cat-friendly.",
        body: "Track cats, volunteers and safe spots on one screen.",
      },
      {
        title: "With them, even at night.",
        body: "A street cat under the night lights — every hour, every neighborhood.",
      },
    ],
    appName: "StrayPaw",
    tagline: "Stray cats of your neighbourhood",
    footerDesc: "Built with care for street cats. Every paw matters.",
    footerDiscover: "Discover",
    footerCommunity: "Community",
    footerConnect: "Connect",
    footerLinkMap: "Map",
    footerLinkIdentify: "AI Identify",
    footerLinkDatabase: "Cat Database",
    footerLinkObservation: "Observation House",
    footerLinkVolunteers: "Volunteers",
    footerLinkLeaderboard: "Leaderboard",
    footerLinkBadges: "Badges",
    footerLinkSafety: "Safety",
    footerPrivacy: "Privacy Policy",
  },
  id: {
    aiBadge: "AI · Identitas Kucing",
    ctaPrimary: "Daftarkan kucing",
    ctaSecondary: "Basis Data Kucing",
    statCats: "Kucing terdaftar",
    statDogs: "Anjing terdaftar",
    statAnimals: "Hewan terdaftar",
    statSightings: "Laporan darurat",
    statFeeding: "Titik pemberian makan",
    statVaccinated: "Divaksinasi",
    featuresOverline: "Apa yang bisa kamu lakukan",
    f1Title: "Pengenalan kucing bertenaga AI",
    f1Desc:
      "Ambil foto tampak depan, samping, dan belakang; sistem membandingkannya dengan kucing terdaftar di sekitarmu. Kucing yang sama atau baru — kamu yang menentukan.",
    f2Title: "Peta lingkungan",
    f2Desc:
      "Tandai kucing, keadaan darurat, dan titik pemberian makan di seluruh lingkunganmu. Saring berdasarkan area, warna, atau status kesehatan.",
    f2Link: "Peta",
    f3Title: "Kesehatan & vaksinasi",
    f3Desc:
      "Pantau rabies, FVRCP, sterilisasi, dan catatan. Bekali relawan dan dokter hewan setempat dengan data nyata.",
    f4Title: "Laporan darurat",
    f4Desc:
      "Melihat anak kucing dalam kesulitan? Jatuhkan pin lokasi — atau tambahkan foto dengan lokasi — dalam 30 detik dan beri tahu relawan serta dokter hewan terdekat.",
    f4Link: "Laporkan keadaan darurat",
    overline: "Lingkunganmu · Kesejahteraan Kucing Komunitas",
    finalCta: "Bantu kucing di lingkunganmu hari ini.",
    finalCtaSub: "Cukup satu foto untuk memulai.",
    heroAria: "Galeri kucing jalanan",
    heroSlides: [
      {
        title: "Setiap kucing jalanan punya kisah.",
        body: "Daftarkan kucing yang kamu lihat, pantau, dan bagikan dengan relawan di lingkunganmu.",
      },
      {
        title: "Satu mangkuk makanan bisa mengubah hidup.",
        body: "Tandai titik pemberian makan agar tetangga dan relawan melihat lokasi yang sama.",
      },
      {
        title: "Kaki-kaki yang hilang ditemukan lebih cepat.",
        body: "Bagikan kucing hilang dan ditemukan lengkap dengan lokasi agar orang yang tepat cepat menemukannya.",
      },
      {
        title: "Waktu sangat berarti saat darurat.",
        body: "Buat laporan cepat untuk kucing yang terluka atau butuh bantuan.",
      },
      {
        title: "Jadikan lingkunganmu ramah kucing.",
        body: "Pantau kucing, relawan, dan tempat aman dalam satu layar.",
      },
      {
        title: "Bersama mereka, bahkan di malam hari.",
        body: "Seekor kucing jalanan di bawah lampu malam — setiap jam, setiap lingkungan.",
      },
    ],
    appName: "StrayPaw",
    tagline: "Kucing liar di lingkunganmu",
    footerDesc: "Dibuat dengan penuh perhatian untuk kucing jalanan. Setiap kaki berarti.",
    footerDiscover: "Jelajahi",
    footerCommunity: "Komunitas",
    footerConnect: "Terhubung",
    footerLinkMap: "Peta",
    footerLinkIdentify: "Identifikasi AI",
    footerLinkDatabase: "Basis Data Kucing",
    footerLinkObservation: "Rumah Observasi",
    footerLinkVolunteers: "Relawan",
    footerLinkLeaderboard: "Papan Peringkat",
    footerLinkBadges: "Lencana",
    footerLinkSafety: "Keamanan",
    footerPrivacy: "Kebijakan Privasi",
  },
};

function resolveLandingLang(lang) {
  // Kendi çevirisi olan dili kullan; yoksa İngilizce'ye düş (Türkçe'ye değil).
  return LANDING_COPY[lang] ? lang : "en";
}

function landingCopyFor(lang) {
  return LANDING_COPY[resolveLandingLang(lang)];
}

const FOOTER_DISCOVER = [
  { to: "/map", labelKey: "footerLinkMap", icon: MapPin, color: "text-blue-600" },
  // 4 Eyl 2026: `/scan-cat` -> `/kedi-kimligi`. Gerekce ve kural:
  // src/lib/aramaKapsam.test.js (ayni etiket, ayni hedef).
  { to: "/kedi-kimligi", labelKey: "footerLinkIdentify", icon: Sparkles, color: "text-orange-600" },
  { to: "/cats", labelKey: "footerLinkDatabase", icon: Database, color: "text-stone-600" },
  { to: "/observation-house", labelKey: "footerLinkObservation", icon: Home, color: "text-amber-700" },
];

const FOOTER_COMMUNITY = [
  { to: "/volunteers", labelKey: "footerLinkVolunteers", icon: HandHeart, color: "text-rose-600" },
  { to: "/leaderboard", labelKey: "footerLinkLeaderboard", icon: Trophy, color: "text-blue-600" },
  { to: "/badges", labelKey: "footerLinkBadges", icon: PawPrint, color: "text-amber-600" },
  { to: "/safety", labelKey: "footerLinkSafety", icon: Shield, color: "text-emerald-700" },
];

function LandingFooter({ copy }) {
  return (
    <footer className="border-t border-stone-200 bg-white pb-20 md:pb-0" data-testid="landing-footer">
      <div className="max-w-7xl mx-auto px-6 py-8 lg:py-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          <div className="col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-xl overflow-hidden shadow-sm">
                <img src={markaLogosu(lang)} alt={markaAdi(lang)} className="w-full h-full object-cover" />
              </span>
              {/* 🔴 11 EYLÜL — açılış sayfası da `lib/marka.js`ten. `LANDING_COPY`
                  her dilde kendi `appName`/`logoSrc`ini taşıyordu; ülke hiç
                  sorulmuyordu, yani Türkiye'de İngilizce açılışta "StrayPaw"
                  yazıyordu. Sözlükteki alanlar SİLİNMEDİ (footer ve diğer
                  metinler onları kullanıyor), yalnızca marka bloğu tek
                  karara bağlandı. */}
              <div className="font-display font-bold text-base tracking-tight">{markaAdi(lang)}</div>
            </div>
            <p className="text-xs text-stone-500 mt-3 leading-relaxed max-w-xs">{copy.footerDesc}</p>
          </div>

          <div>
            <div className="text-[10px] uppercase tracking-[0.22em] text-stone-500 font-semibold mb-2">
              {copy.footerDiscover}
            </div>
            <ul className="space-y-1.5 text-sm">
              {FOOTER_DISCOVER.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-stone-600 hover:text-orange-700 transition-colors inline-flex items-center gap-1.5">
                    <l.icon size={13} className={l.color} />
                    {copy[l.labelKey]}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-[10px] uppercase tracking-[0.22em] text-stone-500 font-semibold mb-2">
              {copy.footerCommunity}
            </div>
            <ul className="space-y-1.5 text-sm">
              {/* GÜVENLIK-1: guvenlik rehberi yalnizca Turkiye'de acik. */}
              {FOOTER_COMMUNITY.filter(
                (l) => l.to !== "/safety" || guvenlikSayfasiAcikMi(),
              ).map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-stone-600 hover:text-orange-700 transition-colors inline-flex items-center gap-1.5">
                    <l.icon size={13} className={l.color} />
                    {copy[l.labelKey]}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-[10px] uppercase tracking-[0.22em] text-stone-500 font-semibold mb-2">
              {copy.footerConnect}
            </div>
            <div className="flex items-center gap-2">
              <a
                href={`mailto:${DESTEK_EPOSTA}`}
                aria-label="E-posta"
                className="inline-flex items-center gap-2 h-9 px-3 rounded-lg border border-stone-200 text-sm text-stone-600 hover:text-orange-600 hover:border-orange-300 transition-colors"
                data-testid="landing-footer-email-link"
              >
                <Mail size={16} /> {DESTEK_EPOSTA}
              </a>
            </div>
          </div>
        </div>

        <p className="text-[11px] text-stone-400 mt-6 pt-4 border-t border-stone-100">
          © 2026 {markaAdi(lang)} ·{" "}
          <Link
            to="/gizlilik-politikasi"
            data-testid="landing-footer-privacy-link"
            className="hover:text-orange-700 hover:underline"
          >
            {copy.footerPrivacy}
          </Link>
        </p>
      </div>
    </footer>
  );
}

/* LangSwitch KALDIRILDI — dil anahtarı artık her sayfadaki gibi üst menüde
   (Layout header-lang-toggle). Hero'daki eski yerinde Pati Ağı butonu var. */

function LandingHeroCarousel({ copy }) {
  const slides = HERO_SLIDE_META.map((meta, i) => ({
    ...meta,
    title: copy.heroSlides[i]?.title || "",
    body: copy.heroSlides[i]?.body || "",
  }));
  const [index, setIndex] = useState(0);
  const [imgError, setImgError] = useState({});
  // Decode every slide up front.
  //
  // The images are bundled, so the first time each one is shown the browser has
  // to fetch and decode it — and until it does, whatever sits behind shows
  // through. That gap is what made the fallback gradient visible at all. Pull
  // them into the cache while the user is still reading the first slide, and by
  // the time they swipe there is nothing left to wait for.
  useEffect(() => {
    HERO_SLIDE_META.forEach((s) => {
      const img = new Image();
      img.src = s.image;
    });
  }, []);
  const touchStartRef = useRef(null);
  const touchDeltaRef = useRef(0);

  useEffect(() => {
    setIndex(0);
  }, [copy]);

  const goTo = (i) => {
    const next = ((i % slides.length) + slides.length) % slides.length;
    setIndex(next);
  };
  const next = () => goTo(index + 1);
  const prev = () => goTo(index - 1);

  const onTouchStart = (e) => {
    touchStartRef.current = e.touches[0]?.clientX ?? null;
    touchDeltaRef.current = 0;
  };
  const onTouchMove = (e) => {
    if (touchStartRef.current == null) return;
    touchDeltaRef.current = (e.touches[0]?.clientX ?? touchStartRef.current) - touchStartRef.current;
  };
  const onTouchEnd = () => {
    const d = touchDeltaRef.current;
    if (Math.abs(d) > 40) {
      if (d < 0) next();
      else prev();
    }
    touchStartRef.current = null;
    touchDeltaRef.current = 0;
  };

  const slide = slides[index];
  const photoFailed = imgError[index];

  return (
    <div
      // mt-3: başlığın altındaki nefes payı geri geldi (buton bandı kalkınca
      // resim tepeye yapışmıştı). Yükseklik AŞAĞIDA kısıldı — sayfa uzamadı,
      // alt kartlar daha erken görünüyor.
      className="relative overflow-hidden bg-stone-900 mt-3"
      data-testid="hero-section"
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
      role="region"
      aria-roledescription="carousel"
      aria-label={copy.heroAria}
    >
      <div className="absolute inset-0">
        {/* The photo. The gradient below is a FALLBACK, and now behaves like one:
            it is drawn only when the photo has actually failed.
            It used to sit under every slide, always painted, and each time the
            carousel advanced there was a beat before the next photo decoded in
            which the raw gradient flashed through — violet, cyan, rose. It read
            as leftover artwork from another screen, because it looked like
            artwork and belonged to nothing on this one. A fallback should appear
            when the thing it falls back from fails, and not one frame sooner. */}
        {photoFailed && (
          <div className={`absolute inset-0 ${slide.gradient}`} aria-hidden="true" />
        )}
        {!photoFailed && (
          <img
            key={slide.id}
            src={slide.image}
            alt=""
            aria-hidden="true"
            onError={() => setImgError((m) => ({ ...m, [index]: true }))}
            className="absolute inset-0 w-full h-full object-cover"
            data-testid={`home-hero-image-${slide.id}`}
          />
        )}
        <div
          aria-hidden="true"
          className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/15 to-black/10"
        />
      </div>

      <div className="relative px-6 sm:px-10 flex flex-col justify-between pt-3 pb-16 sm:pt-5 sm:pb-24 lg:pt-6 lg:pb-32 min-h-[264px] sm:min-h-[320px]">
        <div className="mt-3 sm:mt-6">
          <div
            key={`text-${slide.id}-${copy.heroSlides[0]?.title}`}
            className="max-w-xl text-white animate-[fade-in_400ms_ease-out]"
            data-testid={`home-hero-slide-${slide.id}`}
          >
            <div className={`text-[11px] font-bold uppercase tracking-[0.22em] ${slide.accent}`}>
              {index + 1} / {slides.length}
            </div>
            <h2
              className="mt-2 font-display font-extrabold tracking-tight leading-[1.15] drop-shadow text-2xl sm:text-3xl sm:leading-tight lg:text-4xl"
              data-testid="home-hero-title"
            >
              {slide.title}
            </h2>
            <p
              className="mt-2 text-sm sm:text-base text-white/90 leading-relaxed drop-shadow-sm"
              data-testid="home-hero-body"
            >
              {slide.body}
            </p>
          </div>

          <div className="mt-5 flex items-center gap-3">
            <div className="flex items-center gap-1.5" role="tablist" data-testid="home-hero-dots">
              {slides.map((s, i) => {
                const active = i === index;
                return (
                  <button
                    key={s.id}
                    type="button"
                    onClick={() => goTo(i)}
                    role="tab"
                    aria-selected={active}
                    aria-label={`Slide ${i + 1}`}
                    data-testid={`home-hero-dot-${i}`}
                    className={`h-2 rounded-full transition-all ${
                      active ? "w-7 bg-white" : "w-2 bg-white/40 hover:bg-white/70"
                    }`}
                  />
                );
              })}
            </div>
            <div className="flex-1" />
            <button
              type="button"
              onClick={prev}
              data-testid="home-hero-prev"
              aria-label="Previous slide"
              className="hidden sm:inline-flex w-9 h-9 items-center justify-center rounded-full bg-white/15 hover:bg-white/30 text-white backdrop-blur-sm transition"
            >
              <ChevronLeft size={18} />
            </button>
            <button
              type="button"
              onClick={next}
              data-testid="home-hero-next"
              aria-label="Next slide"
              className="hidden sm:inline-flex w-9 h-9 items-center justify-center rounded-full bg-white/15 hover:bg-white/30 text-white backdrop-blur-sm transition"
            >
              <ChevronRight size={18} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

const LANDING_STAT_META = [
  { key: "cats", copyKey: "statCats", icon: CatFaceLogo, to: "/cats", color: "text-orange-600", bg: "bg-orange-50", testid: "landing-stat-cats" },
  { key: "sightings", copyKey: "statSightings", icon: Eye, to: "/sightings", color: "text-blue-600", bg: "bg-blue-50", testid: "landing-stat-sightings" },
  { key: "feeding", copyKey: "statFeeding", icon: Utensils, to: "/feeding/new", color: "text-emerald-600", bg: "bg-emerald-50", testid: "landing-stat-feeding" },
  { key: "vaccinated", copyKey: "statVaccinated", icon: Heart, to: "/cat-vaccinations", color: "text-blue-600", bg: "bg-blue-50", testid: "landing-stat-vaccinated" },
];

export default function Landing() {
  const [skLang, setSkLang] = useState(() => readSkLang());
  // Tap-to-fullscreen lightbox for home-page photos. null = closed, else the
  // (high-res) image URL to show full screen.
  const [lightbox, setLightbox] = useState(null);
  const activeLang = resolveLandingLang(skLang);
  const lc = landingCopyFor(activeLang);
  const [stats, setStats] = useState({ cats: 0, dogs: 0, sightings: 0, feeding_locations: 0, vaccinated: 0 });
  // KOPEK-1: tur secici degisince ana sayfa da yenilensin.
  //
  // KayipSeridi, MapView ve CatList "sk-animal-mode" olayini zaten dinliyordu;
  // ana sayfa atlanmisti. Sonuc: baslikta kedi moduna gecilmisken sayac hala
  // "Registered dogs" gosteriyordu — mod bir kez okunup bir daha bakilmiyordu.
  // TUR-7: deger kullanilmiyor; sadece "sk-animal-mode" olayinda yeniden
  // cizim icin tutuluyor. Gosterim ham moda degil, animalParam() ile
  // hesaplanan ETKIN suzgece bagli — Turkiye'de mod "all" olsa bile
  // suzgec "cat" doner, boylece kopek sayisi TR ekranina hic sizmaz.
  const [, setTurModu] = useState(() => getAnimalMode());
  useEffect(() => {
    const yenile = () => setTurModu(getAnimalMode());
    window.addEventListener("sk-animal-mode", yenile);
    return () => window.removeEventListener("sk-animal-mode", yenile);
  }, []);

  useEffect(() => {
    axios.get(`${apiBase()}/stats`).then((r) => setStats(r.data)).catch(() => {});
  }, []);

  /* Footer'ı DOM'dan elle gizleme KALDIRILDI. Bu sayfa paylaşılan footer'ın
     "hidden" sınıfını ekleyip siliyordu; silme adımı Harita için konmuş
     gizlemeyi de götürüyor, footer orada beliriyor ve sonraki çizimde
     kayboluyordu. Görünürlük artık Layout'ta rotaya göre — tek kural. */

  // Dil artık ÜST MENÜDEN (Layout) değişiyor — diğer sayfalardaki gibi.
  // i18n setLang'i sk_lang'a yazıp storage olayı yayıyor; burada dinleyip
  // yerel kopyayı eşliyoruz ki hero metinleri anında dil değiştirsin.
  useEffect(() => {
    const esitle = (e) => {
      if (!e || e.key === "sk_lang" || e.key === "lang") setSkLang(readSkLang());
    };
    window.addEventListener("storage", esitle);
    return () => window.removeEventListener("storage", esitle);
  }, []);

  return (
    <div className="fade-in" data-sk-lang={activeLang}>
      {/* TUTORIAL-1: ilk ziyarette bir kez gösterilen tanıtım turu. */}
      <IlkAcilisTuru lang={activeLang} />
      {lightbox && (
        <div
          className="fixed inset-0 bg-black/95 flex items-center justify-center"
          onClick={() => setLightbox(null)}
          data-testid="landing-lightbox"
          role="dialog"
          aria-modal="true"
          style={{
            zIndex: 2147483000,
            padding: "calc(var(--sk-safe-top) + 60px) 12px calc(env(safe-area-inset-bottom, 0px) + 16px)",
          }}
        >
          {/* Close — top-LEFT so it never sits under the fixed ACİL pill on the
              right. Tapping the photo or anywhere on the backdrop also closes. */}
          <button
            type="button"
            onClick={() => setLightbox(null)}
            aria-label={activeLang === "tr" ? "Kapat" : "Close"}
            className="fixed w-12 h-12 grid place-items-center rounded-full bg-white/20 hover:bg-white/30 active:scale-95 text-white text-2xl leading-none backdrop-blur border border-white/30"
            style={{ top: "calc(var(--sk-safe-top) + 10px)", left: "12px", zIndex: 2147483001 }}
          >
            ✕
          </button>
          <img
            src={lightbox}
            alt=""
            className="max-w-full max-h-full object-contain rounded-xl shadow-2xl"
          />
        </div>
      )}
      {/* Ana sayfadaki Pati Ağı butonu KALDIRILDI (kullanıcı kararı) —
          giriş noktaları harita ve profil başlıklarında yaşıyor.
          TR/EN de üst menüde (Layout); bu bant artık gereksiz. */}

      <LandingHeroCarousel copy={lc} />

      {/* KAYIP-6: aktif kayıp ilanı varsa hero'nun hemen altında şerit —
          ilk kaydırmada göz önünde, ama açılış manşeti gibi bağırmıyor.
          İlan yokken bileşen null döner, sayfa eski hâlinin tıpkısı. */}
      <KayipSeridi lang={activeLang} />

      <section
        className="max-w-7xl mx-auto px-6 mt-10 sm:mt-14 lg:mt-20 relative z-20 pointer-events-auto"
        style={{ isolation: "isolate" }}
        data-testid="landing-stat-section"
      >
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {LANDING_STAT_META.map((s) => {
            // KOPEK-1: ilk sayac tur secicisini izler. Kopek modunda kopek
            // sayisi, kedi modunda kedi sayisi, "hepsi" modunda toplam.
            // Ilk kopek kaydedildiginde kedi sayaci 133'ten 134'e cikmisti;
            // sayim backend'de ayrildi, gosterim de burada ayriliyor.
            const suzgec = animalParam();
            const sayacAnahtari =
              s.key !== "cats" ? s.copyKey
              : suzgec === "dog" ? "statDogs"
              : suzgec === "cat" ? "statCats"
              : "statAnimals";
            const value =
              s.key === "cats"
                ? (suzgec === "dog" ? (stats.dogs || 0)
                  : suzgec === "cat" ? (stats.cats || 0)
                  : (stats.cats || 0) + (stats.dogs || 0))
              : s.key === "sightings" ? stats.sightings
              : s.key === "feeding" ? stats.feeding_locations
              : stats.vaccinated;
            return (
              <LandingStatCard
                key={`${s.key}-${activeLang}`}
                lang={activeLang}
                copyKey={sayacAnahtari}
                icon={s.icon}
                value={value}
                to={s.to}
                color={s.color}
                bg={s.bg}
                testid={s.testid}
              />
            );
          })}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 py-16 lg:py-20" data-testid="features-section">
        <div className="overline text-stone-500 mb-3">{landingCopyFor(activeLang).featuresOverline}</div>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 stagger">
          <div className="lg:col-span-7 bg-gradient-to-br from-white via-orange-50/30 to-white border border-stone-200 shadow-sm hover:shadow-md transition-shadow ai-photo-card">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 items-center">
              <div>
                <div className="inline-flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-widest text-amber-800 bg-amber-100 px-2 py-0.5 rounded-full mb-3">
                  <Sparkles size={11} /> {lc.aiBadge}
                </div>
                <h3 className="font-display font-bold text-xl sm:text-2xl tracking-tight text-stone-900 leading-tight">
                  {landingCopyFor(activeLang).f1Title}
                </h3>
                <p className="text-stone-600 mt-2 text-sm leading-relaxed">
                  {landingCopyFor(activeLang).f1Desc}
                </p>
                {/* /kedi-kimligi — /scan-cat DEGIL (1 Agu 2026).
                  *
                  * Kullanici bildirimi: "anasayfada bir kedi kaydet butonu
                  * bizi kaldirdigimiz yuvarlak kameranin oldugu sayfaya
                  * aliyor".
                  *
                  * Alt menudeki AI dugmesi Kedi Kimligi'ne cevrilmisti ama
                  * bu giris atlanmisti. Eski `/scan-cat` yuvarlak kilavuz +
                  * "Canli kamerayi ac" ara adimini gosteriyor; yeni akista
                  * uc kare cekilip arama kendiliginden basliyor.
                  *
                  * GERI DONUS: bu satiri `/scan-cat` yapmak yeter. */}
                <Link
                  to="/kedi-kimligi"
                  className="inline-flex items-center gap-1 mt-4 bg-orange-600 hover:bg-orange-700 text-white font-semibold text-sm rounded-lg px-3.5 py-2 shadow-sm transition-all hover:gap-2"
                  data-testid="landing-cta-identify"
                >
                  {landingCopyFor(activeLang).ctaPrimary} <ArrowRight size={14} />
                </Link>
              </div>
              <div className="grid grid-cols-2 ai-photo-grid" data-testid="landing-ai-preview">
                {CAT_PHOTOS.map((u, i) => (
                  <img
                    key={i}
                    src={u}
                    alt=""
                    className="shadow-sm border border-white pointer-events-none select-none"
                    data-testid={`landing-ai-photo-${i}`}
                  />
                ))}
              </div>
            </div>
          </div>

          <div className="lg:col-span-5 bg-white rounded-xl p-6 sm:p-7 border border-stone-200 shadow-sm hover:shadow-md transition-shadow">
            <div className="w-10 h-10 rounded-lg bg-blue-50 grid place-items-center mb-3">
              <MapPin className="text-blue-600" size={18} />
            </div>
            <h3 className="font-display font-bold text-xl tracking-tight text-stone-900 leading-tight">{lc.f2Title}</h3>
            <p className="text-stone-600 mt-2 leading-relaxed text-sm">{lc.f2Desc}</p>
            <Link to="/map" className="inline-flex items-center gap-1 mt-4 text-blue-700 font-semibold text-sm hover:gap-2 transition-all">
              {lc.f2Link} <ArrowRight size={14} />
            </Link>
          </div>

          <div className="lg:col-span-5 bg-white rounded-xl p-6 sm:p-7 border border-stone-200 shadow-sm hover:shadow-md transition-shadow">
            <div className="w-10 h-10 rounded-lg bg-emerald-50 grid place-items-center mb-3">
              <Heart className="text-emerald-600" size={18} />
            </div>
            <h3 className="font-display font-bold text-xl tracking-tight text-stone-900 leading-tight">{lc.f3Title}</h3>
            <p className="text-stone-600 mt-2 leading-relaxed text-sm">{lc.f3Desc}</p>
          </div>

          <div className="lg:col-span-7 bg-white rounded-xl p-6 sm:p-7 border border-stone-200 shadow-sm hover:shadow-md transition-shadow">
            <div className="w-10 h-10 rounded-lg bg-blue-50 grid place-items-center mb-3">
              <Eye className="text-blue-600" size={18} />
            </div>
            <h3 className="font-display font-bold text-xl tracking-tight text-stone-900 leading-tight">{lc.f4Title}</h3>
            <p className="text-stone-600 mt-2 leading-relaxed text-sm max-w-lg">{lc.f4Desc}</p>
            <Link to="/emergencies" className="inline-flex items-center gap-1 mt-4 text-blue-700 font-semibold text-sm hover:gap-2 transition-all">
              {lc.f4Link} <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 pb-12 lg:pb-16">
        <div className="bg-stone-900 text-white rounded-3xl p-10 sm:p-16 text-center relative overflow-hidden grain">
          <div className="overline text-orange-300 mb-3">{lc.overline}</div>
          <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tighter max-w-3xl mx-auto">
            {lc.finalCta}
          </h2>
          <p className="text-stone-300 mt-4">{lc.finalCtaSub}</p>
          <Link to="/cats" data-testid="final-cta-link" className="inline-block mt-8">
            <Button size="lg" className="rounded-xl bg-orange-600 hover:bg-orange-700 gap-2">
              <Database size={18} /> {lc.ctaSecondary}
            </Button>
          </Link>
        </div>
      </section>

      <LandingFooter copy={lc} />
    </div>
  );
}

function LandingStatCard({ lang, copyKey, icon: Icon, value, to, color, bg, testid }) {
  const navigate = useNavigate();
  const label = landingCopyFor(lang)[copyKey];

  const handleClick = (e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    // (Removed a debug toast that surfaced the destination route to the user —
    // "Besleme noktası · /map?layer=feeding" — which looked like a system alert.)
    navigate(to);
  };

  return (
    <div
      role="button"
      tabIndex={0}
      data-testid={testid}
      data-to={to}
      onClick={handleClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleClick(e);
        }
      }}
      className="relative z-10 block w-full cursor-pointer pointer-events-auto select-none bg-white rounded-xl border border-stone-200 p-5 shadow-sm hover:-translate-y-1 hover:shadow-md hover:border-stone-300 active:scale-[0.98] active:opacity-90 transition-transform transition-opacity transition-shadow"
      style={{
        touchAction: "manipulation",
        WebkitTapHighlightColor: "rgba(251, 146, 60, 0.25)",
      }}
    >
      <div className={`w-10 h-10 rounded-xl ${bg} ${color} grid place-items-center mb-3 pointer-events-none`}>
        <Icon size={18} aria-hidden />
      </div>
      <div className="font-display font-bold text-3xl tracking-tight text-stone-900 pointer-events-none">{value}</div>
      <div className="text-xs text-stone-500 mt-1 pointer-events-none">{label}</div>
    </div>
  );
}
